<template>
  <div class="flex flex-col h-full min-h-screen">
    <div class="flex-grow">
      <div class="h-16 max-w-sm mx-auto mt-12">
        <img :src="portal.logo" alt="" class="object-contain w-full h-full">
      </div>
      <div class="max-w-sm mx-auto mt-8 bg-white rounded-md shadow">
        <div class="grid grid-flow-col font-medium text-center bg-gray-50 rounded-t-md">
          <router-link :to="{ name: 'CustomerLogin' }" class="p-4 text-gray-500 cursor-pointer hover:no-underline hover:bg-white rounded-tl-md" active-class="text-gray-800 bg-white">
            Login
          </router-link>
          <router-link :to="{ name: 'CustomerRegister' }" class="p-4 text-gray-500 cursor-pointer hover:no-underline hover:bg-white rounded-tr-md" active-class="text-gray-800 bg-white">
            Register
          </router-link>
        </div>
        <div class="p-6 lg:p-10">
          <router-view />
        </div>
      </div>
    </div>
    <div class="flex items-center justify-center py-8">
      <a href="https://www.fleetbeacon.app?ref=customer" target="_blank" class="flex items-center text-xs text-right text-gray-500 hover:no-underline">
        Powered by <span class="sr-only">Fleetbeacon</span>
        <img src="@/assets/img/logo-dark.svg" class="h-4 ml-2 opacity-75 hover:opacity-100">
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'CustomerAuthScreen',
  

  created () {
    if (this.$route.name === 'CustomerAuth') {
      this.$router.push({ name: 'CustomerLogin' })
    }

    if (this.$cookies.get('customer_token')) {
      this.$router.push({ name: 'CustomerBookingList' })
    }
  },

  computed: {
    ...mapGetters(['account']),
    ...mapState('customer', ['customer']),
    ...mapState(['portal'])
  }
}
</script>